/** PACS converter card reader protocol */
export enum ConverterReaderProtocolEnum {
  /** FRM test mock card reader (for tests, available only on admin tenant) */
  TEST_MOCK_READER = 'TEST_MOCK_READER',
  /** "iButton" protocol */
  I_BUTTION = 'I_BUTTION',
  /** "Wiegand 26" protocol */
  WIEGAND_26 = 'WIEGAND_26',
}
